import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'sp-rating-star',
    changeDetection: ChangeDetectionStrategy.OnPush,
    styles: [],
    template: `<svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        [attr.width]="size"
        [attr.height]="size"
        [attr.stroke]="stroke"
        [attr.fill]="fill"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="2"
    >
        <polygon
            points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"
        ></polygon>
    </svg>`,
    imports: [CommonModule],
})
export class RatingStarComponent {
    @Input() size: number = 32;
    @Input() stroke: string = '#dddddd';
    @Input() fill: string = '#dddddd';
}
